import { render } from "./MBadge.vue?vue&type=template&id=e91ecf0a"
import script from "./MBadge.vue?vue&type=script&lang=js"
export * from "./MBadge.vue?vue&type=script&lang=js"

import "./MBadge.vue?vue&type=style&index=0&id=e91ecf0a&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__